module.exports = __webpack_public_path__ + "static/media/reedFaAki1027.f31584fd.ico";